export const actions = {
    SET_MARKETING_CONSENT: 'SET_MARKETING_CONSENT',
    SET_FIRST_NAME: 'SET_FIRST_NAME',
    SET_LAST_NAME: 'SET_LAST_NAME',
    SET_EMAIL: 'SET_EMAIL',
    SET_TELEPHONE: 'SET_TELEPHONE',
    SET_INVALID: 'SET_INVALID',
    UNSET_INVALID: 'UNSET_INVALID',
    RESET_INVALID: 'RESET_INVALID',
};
